<template>
  <el-input
    clearable
    v-model="colorValue"
    placeholder="请输入颜色"
    size="mini"
    @change="changeColor"
  >
    <template slot="append">
      <el-color-picker
        show-alpha
        v-model="colorValue"
        :predefine="predefineColors"
        size="mini"
        @active-change="changeColor"
        @change="changeColor"
        popper-class="color-poper"
      />
    </template>
  </el-input>
</template>

<script>
export default {
  name: "ColorPicker",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: [String],
      default: ""
    }
  },
  data() {
    return {
      predefineColors: ["#22AC35", "#FBBC00", "#E84E54", "#E88000","#3CCFDC", "#4278FF", "#A552FF", "#9CA9CB", "#ffffff", "#000000",],
      colorValue: ""
    };
  },
  watch: {
    value(val) {
      this.colorValue = val || "";
    }
  },
  mounted() {
    this.colorValue = this.value;
  },
  methods: {
    changeColor(val) {
      this.colorValue = val || "";
      this.$emit("input", this.colorValue);
      this.$emit("change", this.colorValue);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-color-picker--mini,
/deep/.el-color-picker--mini .el-color-picker__trigger {
  width: 23px;
  height: 23px;
}
</style>
<style>
.color-poper .el-color-dropdown__btns .el-button {
  display: none;
}
</style>
